import { Lightning } from '@lightningjs/sdk';
import { ProgressBar } from '../../../../components/shared/ProgressBar';

const Constants = {
  title: {
    fontSize: 32,
    fontFace: 'Regular',
  },
  progress: {
    width: 400,
    height: 4,
    marginTop: 40,
  },
};

export class RecordingHeader extends Lightning.Component {
  static _template() {
    return {
      w: w => w,
      h: h => h,
      Title: {
        text: {
          fontSize: Constants.title.fontSize,
          fontFace: Constants.title.fontFace,
          text: '',
        },
      },
      ProgressBar: {
        type: ProgressBar,
        w: Constants.progress.width,
        h: Constants.progress.height,
        y: Constants.progress.marginTop,
        fillPercentage: 0,
      },
    };
  }

  /**
   * @param {RecordingSpace | undefined} values
   */
  setValues(values) {
    if (values) {
      this.tag('Title').text.text = values.available;
      this.tag('ProgressBar').fillPercentage = values.used / values.max;
    } else {
      this.tag('Title').text.text = '';
      this.tag('ProgressBar').fillPercentage = 0;
    }
  }
}
